import { render, staticRenderFns } from "./user_center.vue?vue&type=template&id=e7904f18&scoped=true&"
import script from "./user_center.vue?vue&type=script&lang=js&"
export * from "./user_center.vue?vue&type=script&lang=js&"
import style0 from "./user_center.vue?vue&type=style&index=0&id=e7904f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7904f18",
  null
  
)

export default component.exports